// extracted by mini-css-extract-plugin
export var menuBars = "styles-module--menu-bars--RGogM";
export var menuClose = "styles-module--menu-close--CBP9W";
export var menuLanguage = "styles-module--menu-language--Hvus4";
export var menuNav = "styles-module--menu-nav--WyIc5";
export var menuWrapper = "styles-module--menu-wrapper--QAj3W";
export var ptCorrection = "styles-module--pt-correction--KpOCU";
export var pbCorrection = "styles-module--pb-correction--ol3Id";